export default __webpack_public_path__ + "static/media/products-grid-vertical-theme2.1c552f90.svg";